<template>
  <div class="">
      <Modal :is-open="true" :showBackButton="false" modelPopupClass="tw-max-w-3xl">
        <div class="tw-text-secondary tw-text-lg tw-leading-6 tw-space-y-4 tw-font-helvetica">
          <h2 class="tw-text-primary tw-font-semibold tw-leading-9">
            Title
          </h2>
          <p>Descriollllllllllllllllllllll</p>         
        </div>
        <template v-slot:footer>
            <div class="tw-mt-4 tw-flex tw-space-x-4">
                  <button @click="goBack" class="btn btn_transparent tw-m-0 tw-flex tw-items-center tw-cursor-pointer">
                    <svg-icon name="solid/step-backward"/> <span class="tw-ml-2">BACK</span>
                  </button>

                  <button @click="next" class="btn btn_transparent tw-m-0 tw-flex tw-items-center">
                    <svg-icon name="solid/step-forward"/> <span class="tw-ml-2">NEXT</span>
                  </button>
            </div>
        </template>
      </Modal>
  </div>

</template>

<script>
import Modal from '@/components/modals/Generic'
export default {
    name: 'Modal',
    props: ['goBack', 'next'],
    components: {
        Modal
    },
}
</script>

<style lang="scss">

</style>
